import { Flex, Switch, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { ReportFormat } from '../types';

type Props = {
  value: ReportFormat;
  onChange: (value: ReportFormat) => void;
};

export function ReportFormatSwitch({ value, onChange }: Props) {
  return (
    <Flex align="center" mb="lg">
      <Text
        size="sm"
        fw={FONT_WEIGHTS.medium}
        c={value === 'LETTER' ? 'gray.8' : 'gray.4'}
        style={{ cursor: 'pointer' }}
        onClick={() => onChange('LETTER')}
      >
        Letter
      </Text>

      <Switch
        checked={value === 'REPORT'}
        onChange={event => onChange(event.currentTarget.checked ? 'REPORT' : 'LETTER')}
        color="brand.6"
        size="md"
        px="lg"
        styles={{
          track: { cursor: 'pointer' },
          thumb: { cursor: 'pointer' },
        }}
      />

      <Text
        size="sm"
        fw={FONT_WEIGHTS.medium}
        c={value === 'REPORT' ? 'gray.8' : 'gray.4'}
        style={{ cursor: 'pointer' }}
        onClick={() => onChange('REPORT')}
      >
        Report
      </Text>
    </Flex>
  );
}
